<template>
  <div style="background: #eee !important">
    <v-container>
      <v-row class="mb-n6">
        <v-col>
          <h3>ຈຳນວນ User</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.key"
          cols="12"
          md="6"
          sm="12"
        >
          <v-card elevation="1">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-icon
                    large
                    @click="$router.push(card.to)"
                  >
                    {{ card.icon }}
                  </v-icon>
                </v-col>
                <v-divider
                  class="mx-4"
                  vertical
                />
                <v-col>
                  <h3 class="primary-color">
                    {{ count(card.key, 'total') }}
                  </h3>
                  <h3>{{ card.title }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h4>
                    <span class="succes-color">{{ count(card.key, 'active') }}</span>
                  </h4>
                  <h4>Active</h4>
                </v-col>
                <v-col>
                  <h4>
                    <span class="red-color">{{ count(card.key, 'inactive') }}</span>
                  </h4>
                  <h4>Inactive</h4>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
/** Each card reads its own group of GET dashboard: {total, active, inactive}. */
const CARDS = [
  {
    key: 'user', title: 'Users', icon: 'mdi-account', to: '/user',
  },
  {
    key: 'driver', title: 'Driver', icon: 'mdi-account-tie', to: '/driver',
  },
  {
    key: 'customer', title: 'Home', icon: 'mdi-account-multiple', to: '/customer',
  },
  {
    key: 'company', title: 'Company', icon: 'mdi-office-building', to: '/company',
  },
];

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Dashboard';
  },
  data() {
    return {
      cards: CARDS,
      data: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('dashboard')
        .then((res) => {
          if (res.data.code == 200) this.data = res.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
    count(group, key) {
      const value = this.data[group] && this.data[group][key];
      return value === undefined || value === null ? '-' : Number(value).toLocaleString();
    },
  },
};
</script>
<style lang="scss">
@import "../../../public/scss/main.scss";
</style>
